import type { SymbolDefinition } from "../types.ts";

export const generator: SymbolDefinition = {
  id: "ep-generator",
  familyKey: "generator",
  deviceKind: "generator",
  version: "0.1.0",
  label: { sv: "Generator", en: "Generator" },
  description: { sv: "Växelströmsgenerator.", en: "AC generator." },
  viewBox: "0 0 48 48",
  svg: `
    <g fill="none" stroke="currentColor" stroke-width="1.5">
      <circle cx="24" cy="24" r="14"/>
      <text x="24" y="28" text-anchor="middle" font-size="10" fill="currentColor" stroke="none">G</text>
      <line x1="24" y1="10" x2="24" y2="2"/>
    </g>
  `,
  terminals: [{ id: "out", kind: "phase", label: "L", position: "top", offset: 0.5 }],
  designationPrefix: "G",
  searchKeywords: ["generator", "växelström"],
};
